import { http } from '../lib/api/http';
import { getSessionUserId, refreshSessionUser } from './sessionUser';

const DEFAULT_REFERRAL_PREFIX = 'FLOTTE';

export async function fetchReferralsByReferrer(referrerId, { perPage = 200 } = {}) {
  const id = referrerId || (await getSessionUserId());
  if (!id) return [];
  try {
    const response = await http.get('/referrals', {
      params: {
        referrer_id: id,
        limit: perPage,
      },
    });
    const data = Array.isArray(response.data) ? response.data : [];
    return data;
  } catch (error) {
    if (error?.status === 401) {
      return [];
    }
    throw error;
  }
}

export async function fetchUserReferralProfile(userId) {
  const targetId = userId || (await getSessionUserId());
  if (!targetId) return null;
  try {
    const response = await http.get(`/users/${encodeURIComponent(targetId)}`);
    const profile = response.data || {};
    if (!profile?.referral_code) {
      const fallbackCode = generateDefaultReferralCode(profile);
      return saveReferralCode(targetId, fallbackCode);
    }
    return profile;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || 'No pudimos recuperar tu perfil de referidos.'
    );
  }
}

const generateDefaultReferralCode = profile => {
  const base =
    profile?.referral_code ||
    profile?.name ||
    profile?.email?.split('@')[0] ||
    profile?.id ||
    DEFAULT_REFERRAL_PREFIX + Math.random().toString(36).slice(2, 6);
  return base
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 14);
};

export async function saveReferralCode(userId, referralCode) {
  const targetId = userId || (await getSessionUserId());
  if (!targetId) {
    throw new Error('No hay usuario autenticado.');
  }

  const normalizedCode =
    (referralCode && referralCode.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 14)) ||
    generateDefaultReferralCode({});

  try {
    const response = await http.patch(`/users/${encodeURIComponent(targetId)}`, {
      referral_code: normalizedCode,
    });
    await refreshSessionUser().catch(() => {});
    return response.data || {};
  } catch (error) {
    if (error?.status === 404) {
      throw new Error('No encontramos tu perfil de usuario.');
    }
    const referralCodeError = error?.response?.data?.referral_code?.message;
    if (referralCodeError) {
      throw new Error(referralCodeError);
    }
    if (error?.response?.message) {
      throw new Error(error.response.message);
    }
    throw error;
  }
}
